import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MediaComponent } from './media.component';
import { NewMediaComponent } from './new_media/new_media.component';
import { ListMediaComponent } from './list_medias/list_media.component';
import { SelectModule } from '../select';
import { ModalModule } from '../modal';
import { PipeModule } from '../pipes';
import { TagModule } from '../tag';
@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    NgbModule,
    SelectModule,
    ModalModule,
    PipeModule,
    TagModule,
  ],
  declarations: [
    MediaComponent,
    NewMediaComponent,
    ListMediaComponent
  ],
  exports: [
    MediaComponent
  ]
})

export class MediaModule { }
